import store from "../../store";
import get from "lodash/get";

const DV360 = {
  enable() {
    //eslint-disable-next-line no-unused-expressions,wrap-iife
    //SCRIPT INYECTADO EN GOOGLE.JS src/pixels/provides/google.js
  },
  wait() {
    return !!window.gtag;
  },
  init() {
    window.gtag("js", new Date());
    window.gtag("config", "DC-10031883");
  },
  consulta() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      send_to: "DC-10031883/pp_co00/ppom-0+standard"
    });
  },
  oferta() {
    if (get(store, "state.esCliente", false)) {
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-10031883/pp_co000/ppsie0+standard"
      });
    }
  }
};

export default DV360;
